module.exports = __webpack_public_path__ + "img/phase2-gallery-07.6ee6b4e3.png";